import { createAction } from '@reduxjs/toolkit';

export const ADD_EMPTY_TIMESPANS = 'timespans/ADD_EMPTY_TIMESPANS';

export const addEmptyTimespans = createAction(
    ADD_EMPTY_TIMESPANS,
    () => ({ payload: { timespans: undefined } }),
);
